/*
 * Copyright (c) 2021
 * Company: G-Portal
 * Filename: use-router.ts
 * Class: use-router.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { Ref, computed, getCurrentInstance } from '@vue/composition-api';
import VueRouter, { Route } from 'vue-router';

export const useRouter = (): { route: Ref<Route>; router: VueRouter } => {
  const vm = getCurrentInstance();

  if (!vm) {
    throw new ReferenceError('No found vue instance');
  }

  const route = computed(() => vm.proxy.$route);

  return { route, router: vm.proxy.$router } as const;
};
